import { client } from '@/client';
import { resolveData } from '@/util/api-helpers';

export async function getCompanyRules(slug) {
   return client.get(`/api/rules/${slug}`)
      .then(resolveData);
}

export async function applyLeadToSortRules({ slug }, lead_id) {
   return client.get(`/api/sort/test/${slug}/${lead_id}`)
      .then(resolveData);
}

export async function updateSortRule(slug, id, update) {
   return client.put(`/api/rules/${slug}/${id}`, update)
      .then(resolveData);
}

export async function storeSortRule(slug, rule) {
   return client.post(`/api/rules/${slug}`, rule)
      .then(resolveData);
}

export async function deleteSortRule(slug, rule) {
   return client.delete(`/api/rules/${slug}/${rule.id}`)
      .then(resolveData);
}

export async function findInterestedCompanies({ id }) {
   return client.get(`/api/sort/find-interested/${id}`)
      .then(resolveData);
}

export async function getRuleDefinitions() {
   return client.get('/api/rules/definitions')
      .then(resolveData);
}
